import type { AiComponentDto } from '@terra/shared-contracts-ai-applications';

export const AI_COMPONENT_TYPE_KEYS: Record<
  AiComponentDto['type'],
  | 'agent'
  | 'subAgent'
  | 'tool'
  | 'mcpServer'
  | 'mcpTool'
  | 'mcpPrompt'
  | 'mcpResource'
  | 'mcpProtocol'
  | 'rag'
  | 'model'
  | 'memory'
  | 'guardrail'
  | 'integration'
> = {
  AGENT: 'agent',
  SUB_AGENT: 'subAgent',
  TOOL: 'tool',
  MCP_SERVER: 'mcpServer',
  MCP_TOOL: 'mcpTool',
  MCP_PROMPT: 'mcpPrompt',
  MCP_RESOURCE: 'mcpResource',
  MCP_PROTOCOL: 'mcpProtocol',
  RAG: 'rag',
  MODEL: 'model',
  MEMORY: 'memory',
  GUARDRAIL: 'guardrail',
  INTEGRATION: 'integration',
};
